import {
  START_REPEATORDER_TO_ORDERPAD,
  SUCCESS_REPEATORDER_TO_ORDERPAD,
  ERROR_REPEATORDER_TO_ORDERPAD,
  START_CREATE_ORDER_PAD,
  SUCCESS_CREATE_ORDERPAD,
  ERROR_CREATE_ORDERPAD,
  RESET_ORDER_PAD_STATE,
  START_CREATE_TODAY_ORDER_PAD,
  SUCCESS_CREATE_TODAY_ORDERPAD,
  ERROR_CREATE_TODAY_ORDERPAD,
} from "Actions/OrderPadAction";

const initialState = {
  repeatOrderToOrderPad: {
    loading: false,
    data: {},
    error: {},
  },
  createOrderPadData: {
    loading: false,
    data: {},
    error: {},
  },
  createTodayOrderPadData: {
    loading: false,
    data: {},
    error: {},
  },
};

export const OrderPadReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ORDER_PAD_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_REPEATORDER_TO_ORDERPAD: {
      return {
        ...state,
        repeatOrderToOrderPad: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_REPEATORDER_TO_ORDERPAD: {
      return {
        ...state,
        repeatOrderToOrderPad: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_REPEATORDER_TO_ORDERPAD: {
      return {
        ...state,
        repeatOrderToOrderPad: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_CREATE_ORDER_PAD: {
      return {
        ...state,
        createOrderPadData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_ORDERPAD: {
      return {
        ...state,
        createOrderPadData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_ORDERPAD: {
      return {
        ...state,
        createOrderPadData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_CREATE_TODAY_ORDER_PAD: {
      return {
        ...state,
        createTodayOrderPadData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_TODAY_ORDERPAD: {
      return {
        ...state,
        createTodayOrderPadData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_TODAY_ORDERPAD: {
      return {
        ...state,
        createTodayOrderPadData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
